module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAyAQMAAADx486/AAAABlBMVEXcFDz////vuDXSAAAAE0lEQVQoz2P4DwcMo0wIcxSgAwBb0PkHxoHwIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/flags/pl.png
// module id = wIEm
// module chunks = 2